import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, wrapper, title, image, rightMargin, listBox } from './LastPageStyle';
import imgWorld from '../../assets/media/proc2-world.jpg';
import IndustryArea from '../../components/IndustryArea';

const SmartManufacturingLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>Mit ZMC erfolgreich zu «Smart Manufacturing»</div>
                <h2>Wir transformieren Ihre Produktion zum Wettbewerbsfaktor</h2>
                <p>
                    ZMC bietet umfassende Beratungs-, Umsetzungs- &amp; Trainingsleistungen im Kompetenzfeld
                    «Produktion» an.
                </p>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgWorld} alt="International" />
                    <div className={listBox}>
                        <b>Digital, Smart Operations</b>
                        <ul style={{ paddingBottom: '1.5mm' }}>
                            <li>Smart Manufacturing Assessment</li>
                            <li>Smart Manufacturing/Factory, Industrie 4.0</li>
                            <li>Simulation von Produktionsnetzwerken, -standorten und -prozessen</li>
                            <li>OpEx 4.0, Operations Data Monitoring</li>
                            <li>Evaluation und Implementierung digitaler, disruptiver Technologien</li>
                        </ul>
                        <b>Operations Improvement</b>
                        <ul style={{ paddingBottom: '1.5mm' }}>
                            <li>360° Operations Excellence Assessment</li>
                            <li>Leistungs- und Effizienzsteigerung</li>
                            <li>Operations &amp; Maintenance Excellence</li>
                            <li>Komplexitätsmanagement</li>
                            <li>Lean Six Sigma, kontinuierliche Verbesserung, Shopfloor Management</li>
                            <li>Zero Loss-Analyse, Wertstromverbesserung</li>
                            <li>Produktionslogistik</li>
                            <li>Produktionsplanung und -steuerung</li>
                            <li>Produktionorganisation und -prozesse</li>
                            <li>Produktions-IT, ERP, MES</li>
                        </ul>
                        <b>Operations Strategy</b>
                        <ul>
                            <li>Produktionsstrategie</li>
                            <li>Produktionstechnologiestrategie &amp; -Management</li>
                            <li>Technologietransfer in der Produktion</li>
                            <li>Produktionsnetzwerk und Footprint Design</li>
                            <li>Make or Buy, Outsourcing, Insourcing</li>
                            <li>Erweiterung und Verlagerung der Produktion</li>
                            <li>Standort, Standortbewertung und -optimierung</li>
                        </ul>
                    </div>
                </div>
                <h2>Namhafte Kunden vertrauen uns seit über 25 Jahren</h2>
                <p>Internationale Unternehmen wählen uns als Partner, um «Smart Manufacturing» zu realisieren</p>

                <IndustryArea />

                <h2>Nachhaltige Resultate und ein attraktiver Payback</h2>
                <p>
                    Sie setzen auf ein erfahrenes Team mit internationaler Erfahrung. Unser Fokus auf «Digitale
                    Geschäftstransformation» sowie «Smart Manufacturing» und unsere Umsetzungsstärke garantieren
                    nachhaltige Resultate.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default SmartManufacturingLastPage;
